import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import { FetchGroup, FetchGroupFailure, FetchGroupSuccess } from '../actions';
import { Group } from '../models/group';
import { GroupState } from '../models/group.state';

@Injectable()
export class GroupService {
    @Select(GroupState.getEntities)
    group$: Observable<Group[]>;

    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getGroup(): Group {
        return this._store.selectSnapshot(GroupState.getEntity);
    }

    getGroupById(id: string): Group {
        return GroupState.getEntity(this._store.selectSnapshot(GroupState), id);
    }

    async fetchGroup(groupId: string): Promise<boolean> {
        this._store.dispatch(new FetchGroup(groupId));

        return await this._actionHelper.race(FetchGroupSuccess, FetchGroupFailure).toPromise();
    }
}
